
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 55 55"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","stroke":"currentColor","stroke-width":"2.4","stroke-miterlimit":"10","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('path',{attrs:{"d":"M44.069 19.704a3.334 3.334 0 01-3.324 3.341H14.153a3.334 3.334 0 01-3.324-3.34V6.34C10.83 4.497 12.32 3 14.153 3h26.592a3.334 3.334 0 013.324 3.34v13.364z"}}),_c('path',{attrs:{"d":"M15.296 13.023a3.332 3.332 0 013.324-3.341 3.332 3.332 0 013.324 3.34 3.332 3.332 0 01-3.324 3.342 3.332 3.332 0 01-3.324-3.341zm24.41 0a3.332 3.332 0 01-3.324 3.34 3.332 3.332 0 01-3.324-3.34 3.332 3.332 0 013.324-3.341 3.332 3.332 0 013.324 3.34zM24.125 27.509h6.648m-6.648 4.437h6.648m13.296 4.464h-33.24L14.153 52h26.592l3.324-15.59zM43.03 43.082l7.756-6.125-1.108-5.011M51.89 23.046A5.575 5.575 0 0153 26.39c0 3.076-2.48 5.568-5.54 5.568-1.81 0-3.42-.873-4.43-2.223M11.937 43.082l-7.756-6.125 1.108-5.011M3.11 23.045A5.575 5.575 0 002 26.391c0 3.076 2.48 5.568 5.54 5.568 1.81 0 3.42-.873 4.43-2.223"}}),_c('path',{attrs:{"d":"M19.728 43.09H35.24V52H19.728v-8.91z"}})])])
          )
        }
      }
    